// Analytics: Google Analytics 4 + Meta Pixel.
// IDs come from frontend/.env — if empty, nothing is loaded (safe no-op).
const GA4_ID = process.env.REACT_APP_GA4_ID;
const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;

let initialized = false;

export const initAnalytics = () => {
  if (initialized) return;
  initialized = true;

  if (GA4_ID) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    window.gtag("config", GA4_ID, { send_page_view: false });
  }

  if (PIXEL_ID) {
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    /* eslint-enable */
    window.fbq("init", PIXEL_ID);
  }
};

export const trackPageView = (path) => {
  if (window.gtag) window.gtag("event", "page_view", { page_path: path });
  if (window.fbq) window.fbq("track", "PageView");
};

export const trackBookingCompleted = ({ tourName, value }) => {
  if (window.gtag) window.gtag("event", "booking_completed", { tour_name: tourName, value, currency: "MXN" });
  if (window.fbq) window.fbq("track", "Lead", { content_name: tourName, value, currency: "MXN" });
};

export const trackPurchase = ({ value }) => {
  if (window.gtag) window.gtag("event", "purchase", { value, currency: "MXN" });
  if (window.fbq) window.fbq("track", "Purchase", { value, currency: "MXN" });
};

export const trackWhatsAppClick = (source) => {
  if (window.gtag) window.gtag("event", "whatsapp_click", { source });
  if (window.fbq) window.fbq("trackCustom", "WhatsAppClick", { source });
};
